import React, { useState, useRef, useEffect, useId } from "react";
import { Modal, Nav, Tab, Button } from "react-bootstrap";
import { toast } from "react-toastify";

import ContactPanelForEditPopups from "../../../TreatmentPage/components/ContactPanelForEditPopups";
import SelectStateModal from "../../../TreatmentPage/modals/state-modal/SelectStateModal";
import { api_without_cancellation } from "../../../../api/api";
import PR from "../../../../assets/state-svg/puerto-rico";
import GU from "../../../../assets/state-svg/guam";
import MP from "../../../../assets/state-svg/marian";
import VI from "../../../../assets/state-svg/us-virigin-island";
import { getCaseId, getClientId } from "../../../../Utils/helper";

import PropertyDamageEntityTab, {
  getPropertyDamageEntity,
  getPropertyDamageEntityPayload,
} from "./property-damage-entity-tab";
import PropertyDamageInsuranceTab from "./property-damage-insurance-tab";

function EditModalDamage({ show, handleClose, isEdit = false, refetch, selectedData }) {
  const modalBodyRef = useRef(null);
  const formId = useId();

  const [insurancesData, setInsurancesData] = useState([]);
  const clientId = getClientId();
  const currentCaseId = getCaseId();

  const fetchInusrance = async () => {
    try {
      const response = await api_without_cancellation.get(
        `/api/insurances/${clientId}/${currentCaseId}/`
      );
      setInsurancesData(response?.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchInusrance();
  }, []);

  const [addData, setData] = useState({
    damageDescription: "",
    damageSeverity: "",
    additionalPdExp: "",

    // insurnace
    selectedinsurance: "",

    // Entity
    selectedEntity: null,

    // Vehicle Information
    vehicleMake: "",
    vehicleModel: "",
    vehicleYear: "",
    vehicleMileage: "",
    vin: "",
    plate_number: "",
    color: "",
    owned: false,
    value: "",
    amount_owed: "",

    // Location
    name: "",
    add1: "",
    add2: "",
    city: "",
    state: "",
    zip: "",
    fax: "",
    phone: "",
    webUrl: "",
    email: "",
  });

  const [_searchInsurance, _setInsurance] = useState("");
  const [providerType, setProviderType] = useState("entity");
  const handleModalClose = () => {
    handleClose();
  };

  const _formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 10);

    const part1 = digits.slice(0, 3);
    const part2 = digits.slice(3, 6);
    const part3 = digits.slice(6, 10);

    if (digits.length <= 3) return part1;
    if (digits.length <= 6) return `(${part1}) - ${part2}`;
    return `(${part1}) - ${part2} ${part3}`;
  };
  const formatCurrency = (value) => {
    if (!value) return "";

    const number = value.replace(/[^0-9.]/g, "");
    const parts = number.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return `$${parts.join(".").slice(0, parts[0].length + 3)}`;
  };

  const [statesAbrs, setStatesAbrs] = useState([]);
  const stateMap = {
    PR: PR,
    GU: GU,
    VI: VI,
    MP: MP,
  };
  const specialStates = Object.keys(stateMap);
  const fetchSatesData = async () => {
    try {
      const response = await api_without_cancellation.get("/api/states/");
      if (response.status === 200) {
        setStatesAbrs(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchSatesData();
  }, []);

  const [stateShow, setStateShow] = React.useState(false);
  const handleStateShow = () => {
    setStateShow(!stateShow);
  };

  const handleDelete = async () => {
    try {
      const response = await api_without_cancellation.delete(
        `/api/property-damage/${clientId}/${currentCaseId}/${selectedData?.id}/`
      );
      if (response.status === 204) {
        handleClose();
        toast.success("Successfully Deleted Property Damage Information");
        refetch();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!addData.selectedEntity?.id) {
      setProviderType("entity");
      toast.error("Please select an entity for this property damage.");
      return;
    }

    try {
      setSaving(true);
      if (!isEdit) {
        const payload = {
          ...getPropertyDamageEntityPayload(addData.selectedEntity),
          make: addData?.vehicleMake,
          model: addData?.vehicleModel,
          year: addData?.vehicleYear,
          mileage: addData?.vehicleMileage,
          vin: addData?.vin,
          plate_number: addData?.plate_number,
          color: addData?.color,
          value: addData?.value,
          amount_owed: addData?.amount_owed,
          ownership: addData?.owned === true ? "Owned" : "Leased",
          damage_description: addData?.damageDescription,
          damage_severity: addData?.damageSeverity || undefined,
          additional_pd_expense: addData?.additionalPdExp,
          insurance_id: addData?.selectedinsurance,
          vehicle_location: {
            name: addData?.name || "",
            address1: addData?.add1 || "",
            address2: addData?.add2 || "",
            city: addData?.city || "",
            state: addData?.state || "",
            zip: addData?.zip || "",
            phone_number: addData?.phone || "",
            fax: addData?.fax || "",
            email: addData?.email || "",
            website: addData?.webUrl || "",
          },
        };
        const response = await api_without_cancellation.post(
          `/api/property-damage/${clientId}/${currentCaseId}/`,
          payload
        );
        if (response.status === 201) {
          handleClose();
          toast.success("Successfully Added Property Damage");
          await refetch();
        }
      } else {
        const payload = {
          ...getPropertyDamageEntityPayload(addData.selectedEntity),
          make: addData?.vehicleMake,
          model: addData?.vehicleModel,
          year: addData?.vehicleYear,
          mileage: addData?.vehicleMileage,
          vin: addData?.vin,
          plate_number: addData?.plate_number,
          color: addData?.color,
          value: addData?.value,
          amount_owed: addData?.amount_owed,
          ownership: addData?.owned === true ? "Owned" : "Leased",
          damage_description: addData?.damageDescription,
          damage_severity: addData?.damageSeverity || undefined,
          additional_pd_expense: addData?.additionalPdExp,
          insurance_id: addData?.selectedinsurance,
          vehicle_location: {
            name: addData?.name || "",
            address1: addData?.add1 || "",
            address2: addData?.add2 || "",
            city: addData?.city || "",
            state: addData?.state || "",
            zip: addData?.zip || "",
            phone_number: addData?.phone || "",
            fax: addData?.fax || "",
            email: addData?.email || "",
            website: addData?.webUrl || "",
          },
        };
        const response = await api_without_cancellation.patch(
          `/api/property-damage/${clientId}/${currentCaseId}/${selectedData?.id}/`,
          payload
        );

        if (response.status === 200) {
          handleClose();
          toast.success("Successfully Edit The Property Damage");
          refetch();
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    if (selectedData && show) {
      setData({
        ...addData,
        vehicleMake: selectedData?.make,
        vehicleModel: selectedData?.model || "",
        vehicleYear: selectedData?.year || "",
        vehicleMileage: selectedData?.mileage || "",
        vin: selectedData?.vin || "",
        plate_number: selectedData?.plate_number || "",
        color: selectedData?.color || "",
        value: selectedData?.value || "",
        amount_owed: selectedData?.amount_owed || "",
        owned: selectedData?.ownership === "Owned" ? true : false,
        damageDescription: selectedData?.damage_description || "",
        damageSeverity: selectedData?.damage_severity || "",
        additionalPdExp: selectedData?.additional_pd_expense || "",
        selectedinsurance: selectedData?.insurance?.id || "",
        selectedEntity: getPropertyDamageEntity(selectedData),
        name: selectedData?.vehicle_location?.name || "",
        add1: selectedData?.vehicle_location?.address1 || "",
        add2: selectedData?.vehicle_location?.address2 || "",
        city: selectedData?.vehicle_location?.city || "",
        state: selectedData?.vehicle_location?.state || "",
        zip: selectedData?.vehicle_location?.zip || "",
        phone: selectedData?.vehicle_location?.phone_number || "",
        fax: selectedData?.vehicle_location?.fax || "",
        email: selectedData?.vehicle_location?.email || "",
        webUrl: selectedData?.vehicle_location?.website || "",
      });
    }
  }, [selectedData, show]);

  const handlePhoneChange = (e) => {
    const numbers = e.target.value.replace(/\D/g, "");
    let formattedValue = numbers;

    if (numbers.length > 3) {
      formattedValue = `(${numbers.slice(0, 3)})`;
      if (numbers.length > 3) {
        formattedValue += ` ${numbers.slice(3, 6)}`;
      }
      if (numbers.length > 6) {
        formattedValue += `-${numbers.slice(6, 10)}`;
      }
    }

    setData({
      ...addData,
      phone: formattedValue,
    });
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleModalClose}
        dialogClassName="max-property-dmg-add-edit modal-dialog-centered "
        contentClassName="custom-modal-new-provider"
        size="lg"
        style={{
          opacity: stateShow ? "0.5" : "1",
        }}
      >
        <div style={{ minHeight: "275px" }}>
          <Modal.Header
            style={{
              borderBottom: "0px",
            }}
            className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
          >
            <Modal.Title
              className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
              id="modal_title"
              style={{ fontSize: "14px", fontWeight: "600" }}
            >
              {/* Header */}
              Edit Property Damage
            </Modal.Title>
          </Modal.Header>
          <Modal.Body ref={modalBodyRef} style={{ minHeight: "300px", padding: "0px" }}>
            <div className="custom-tab">
              <Tab.Container activeKey={providerType} onSelect={setProviderType}>
                <Nav
                  variant="tabs"
                  className="justify-content-around"
                  style={{ marginTop: "5px", marginBottom: "5px" }}
                >
                  <Nav.Link
                    className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite apply-before"
                    eventKey="entity"
                    onClick={() => setProviderType("entity")}
                  >
                    Parties
                  </Nav.Link>
                  <Nav.Link
                    className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite"
                    eventKey="vehicle-information"
                    onClick={() => setProviderType("vehicle-information")}
                  >
                    Vehicle Information
                  </Nav.Link>
                  <Nav.Link
                    className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite"
                    eventKey="damageLocation"
                    onClick={() => setProviderType("damageLocation")}
                  >
                    Vehicle Location
                  </Nav.Link>

                  <Nav.Link
                    className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite"
                    eventKey="damageDescription"
                    onClick={() => setProviderType("damageDescription")}
                  >
                    Damage Description
                  </Nav.Link>

                  <Nav.Link
                    className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite"
                    eventKey="additionalPDExp"
                    onClick={() => setProviderType("additionalPDExp")}
                  >
                    Additional PD Expenses
                  </Nav.Link>

                  <Nav.Link
                    className="new-provider-nav-link-hover-effect nav-link Pad8 tab-ite apply-after"
                    eventKey="insuranceResponsible"
                    onClick={() => setProviderType("insuranceResponsible")}
                  >
                    Insurance Responsible
                  </Nav.Link>
                </Nav>
                <div className="">
                  <Tab.Content>
                    {/* tab.pane */}

                    <Tab.Pane eventKey="entity">
                      <PropertyDamageEntityTab
                        clientId={clientId}
                        caseId={currentCaseId}
                        selectedEntity={addData.selectedEntity}
                        onSelect={(selectedEntity) =>
                          setData((currentData) => ({ ...currentData, selectedEntity }))
                        }
                      />
                    </Tab.Pane>

                    <Tab.Pane eventKey={"vehicle-information"}>
                      <div className="row mx-0 align-items-center custom-margin-bottom">
                        <div className="col-md-2 text-start p-l-5 pe-0">
                          <span className="d-inline-block text-grey text-nowrap">Vehicle Make</span>
                        </div>
                        <div className="col-md-4 p-l-5 pe-0">
                          <input
                            type="text"
                            placeholder="Enter Vehicle Make"
                            className="form-control rounded-0 height-25"
                            onChange={(e) => {
                              setData({
                                ...addData,
                                vehicleMake: e.target.value,
                              });
                            }}
                            value={addData?.vehicleMake}
                          />
                        </div>

                        <div className="col-md-2 text-start p-l-5 pe-0">
                          <span className="d-inline-block text-grey text-nowrap">
                            Vehicle Model
                          </span>
                        </div>
                        <div className="col-md-4 p-l-5 p-r-5">
                          <input
                            type="text"
                            placeholder="Enter Vehicle Model"
                            className="form-control rounded-0 height-25"
                            onChange={(e) => {
                              setData({
                                ...addData,
                                vehicleModel: e.target.value,
                              });
                            }}
                            value={addData?.vehicleModel}
                          />
                        </div>
                      </div>

                      <div className="row mx-0 align-items-center custom-margin-bottom">
                        <div className="col-md-2 text-start p-l-5 pe-0">
                          <span className="d-inline-block text-grey text-nowrap">Vehicle Year</span>
                        </div>
                        <div className="col-md-4 p-l-5 pe-0">
                          <input
                            type="text"
                            placeholder="Enter Vehicle Year"
                            className="form-control rounded-0 height-25"
                            onChange={(e) => {
                              setData({
                                ...addData,
                                vehicleYear: e.target.value,
                              });
                            }}
                            value={addData?.vehicleYear}
                          />
                        </div>
                        <div className="col-md-2 text-start p-l-5 pe-0">
                          <span className="d-inline-block text-grey text-nowrap">
                            Vehicle Mileage
                          </span>
                        </div>

                        <div className="col-md-4 p-l-5 p-r-5">
                          <input
                            type="number"
                            placeholder="Enter Vehicle Mileage"
                            className="form-control rounded-0 height-25"
                            onChange={(e) => {
                              setData({
                                ...addData,
                                vehicleMileage: e.target.value,
                              });
                            }}
                            value={addData?.vehicleMileage}
                          />
                        </div>
                      </div>

                      <div className="row mx-0 align-items-center custom-margin-bottom">
                        <div className="col-md-2 text-start p-l-5 pe-0">
                          <label
                            className="d-inline-block text-grey text-nowrap mb-0"
                            htmlFor={`${formId}-vin`}
                          >
                            VIN Number
                          </label>
                        </div>
                        <div className="col-md-4 p-l-5 pe-0">
                          <input
                            id={`${formId}-vin`}
                            name="vin"
                            type="text"
                            placeholder="Enter VIN Number"
                            className="form-control rounded-0 height-25"
                            value={addData.vin}
                            onChange={(e) =>
                              setData((currentData) => ({ ...currentData, vin: e.target.value }))
                            }
                          />
                        </div>
                        <div className="col-md-2 text-start p-l-5 pe-0">
                          <label
                            className="d-inline-block text-grey text-nowrap mb-0"
                            htmlFor={`${formId}-plate_number`}
                          >
                            Plate Number
                          </label>
                        </div>
                        <div className="col-md-4 p-l-5 p-r-5">
                          <input
                            id={`${formId}-plate_number`}
                            name="plate_number"
                            type="text"
                            placeholder="Enter Plate Number"
                            className="form-control rounded-0 height-25"
                            value={addData.plate_number}
                            onChange={(e) =>
                              setData((currentData) => ({
                                ...currentData,
                                plate_number: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>

                      <div className="row mx-0 align-items-center custom-margin-bottom">
                        {/* Vehicle Value */}
                        <div className="col-md-2 text-start p-l-5 pe-0">
                          <span className="d-inline-block text-grey text-nowrap">
                            Vehicle Value
                          </span>
                        </div>

                        <div className="col-md-4 p-l-5 pe-0">
                          <input
                            type="text"
                            placeholder="$0.00"
                            className="form-control rounded-0 height-25"
                            value={formatCurrency(addData?.value || "")}
                            onChange={(e) => {
                              const rawValue = e.target.value.replace(/[^0-9.]/g, "");
                              setData({
                                ...addData,
                                value: rawValue,
                              });
                            }}
                          />
                        </div>

                        {/* Amount Owed */}
                        <div className="col-md-2 text-start p-l-5 pe-0">
                          <span className="d-inline-block text-grey text-nowrap">Amount Owed</span>
                        </div>

                        <div className="col-md-4 p-l-5 p-r-5">
                          <input
                            type="text"
                            placeholder="$0.00"
                            className="form-control rounded-0 height-25"
                            value={formatCurrency(addData?.amount_owed || "")}
                            onChange={(e) => {
                              const rawValue = e.target.value.replace(/[^0-9.]/g, "");
                              setData({
                                ...addData,
                                amount_owed: rawValue,
                              });
                            }}
                          />
                        </div>
                      </div>

                      <div className="row mx-0 align-items-center custom-margin-bottom">
                        {/* Owned / Leased */}
                        <div className="col-md-2 text-start p-l-5 pe-0">
                          <span className="d-inline-block text-grey text-nowrap">Ownership</span>
                        </div>

                        <div className="col-md-4 p-l-5 p-r-5 d-flex align-items-center">
                          <div
                            className="d-flex align-items-center me-2"
                            style={{
                              gap: "5px",
                            }}
                          >
                            <input
                              className="form-check mb-0"
                              style={{
                                minHeight: "14px",
                              }}
                              type="radio"
                              name="vehicleOwnership"
                              id="owned"
                              checked={addData?.owned === true}
                              onChange={() =>
                                setData({
                                  ...addData,
                                  owned: true,
                                })
                              }
                            />
                            <label className="form-check-label mb-0" htmlFor="owned">
                              Owned
                            </label>
                          </div>

                          <div
                            className="d-flex align-items-center me-2"
                            style={{
                              gap: "5px",
                            }}
                          >
                            <input
                              className="form-check mb-0"
                              style={{
                                minHeight: "14px",
                              }}
                              type="radio"
                              name="vehicleOwnership"
                              id="leased"
                              checked={addData?.owned === false}
                              onChange={() =>
                                setData({
                                  ...addData,
                                  owned: false,
                                })
                              }
                            />
                            <label className="form-check-label mb-0" htmlFor="leased">
                              Leased
                            </label>
                          </div>
                        </div>
                        <div className="col-md-2 text-start p-l-5 pe-0">
                          <label
                            className="d-inline-block text-grey text-nowrap mb-0"
                            htmlFor={`${formId}-color`}
                          >
                            Color
                          </label>
                        </div>
                        <div className="col-md-4 p-l-5 p-r-5">
                          <input
                            id={`${formId}-color`}
                            name="color"
                            type="text"
                            placeholder="Enter Color"
                            className="form-control rounded-0 height-25"
                            value={addData.color}
                            onChange={(e) =>
                              setData((currentData) => ({ ...currentData, color: e.target.value }))
                            }
                          />
                        </div>
                      </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey={"damageLocation"}>
                      <div className="row m-0">
                        <ContactPanelForEditPopups
                          panel_name={"Vehicle LOCATION"}
                          pageName={"propertyDamage"}
                          websiteURL={addData?.webUrl}
                          className="m-b-5"
                          dynamic_label={"Company Name"}
                          name={addData?.name}
                          address1={addData?.add1}
                          address2={addData?.add2}
                          email={addData?.email}
                          phone_number={addData?.phone}
                          city={addData?.city}
                          state={addData?.state}
                          zip_code={addData?.zip}
                          fax_number={addData?.fax}
                        />

                        <div className="d-flex-1">
                          <div
                            className="d-flex align-items-center"
                            style={{ marginBottom: "5px" }}
                          >
                            {/* <div className="m-r-5 text-end" style={{ width: "100px" }}>
                                  <span className="d-inline-block text-grey">Name:</span>
                                </div> */}
                            <div className="col-12 p-r-5 ps-0">
                              <input
                                type="text"
                                id="completed_location_name"
                                className="Treatment-page-modal-form-control"
                                placeholder="Name"
                                value={addData?.name}
                                onFocus={(e) => {
                                  e.target.style.color = "black";
                                  e.target.placeholder = "";
                                }}
                                onBlur={(e) => {
                                  e.target.style.color = "var(--primary-25)";
                                  e.target.placeholder = "Name";
                                }}
                                onChange={(e) => {
                                  setData({
                                    ...addData,
                                    name: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>

                          <div
                            className="d-flex align-items-center"
                            style={{ marginBottom: "5px" }}
                          >
                            {/* <div className="m-r-5 text-end" style={{ width: "100px" }}>
                                  <span className="d-inline-block text-grey">
                                    <nobr>Address 1, 2:</nobr>
                                  </span>
                                </div> */}
                            <div className="col-6 ps-0 p-r-5">
                              <input
                                type="text"
                                id="completed_location_address1"
                                className="Treatment-page-modal-form-control"
                                name="medical_address1"
                                placeholder="Address 1"
                                value={addData?.add1}
                                onFocus={(e) => {
                                  e.target.style.color = "black";
                                  e.target.placeholder = "";
                                }}
                                onBlur={(e) => {
                                  e.target.style.color = "var(--primary-25)";
                                  e.target.placeholder = "Address 1";
                                }}
                                onChange={(e) => {
                                  setData({
                                    ...addData,
                                    add1: e.target.value,
                                  });
                                }}
                              />
                            </div>
                            <div className="col-6 ps-0 p-r-5">
                              <input
                                type="text"
                                id="completed_location_address2"
                                className="Treatment-page-modal-form-control"
                                name="medical_address2"
                                placeholder="Address 2"
                                value={addData?.add2}
                                onFocus={(e) => {
                                  e.target.style.color = "black";
                                  e.target.placeholder = "";
                                }}
                                onBlur={(e) => {
                                  e.target.style.color = "var(--primary-25)";
                                  e.target.placeholder = "Address 2";
                                }}
                                onChange={(e) => {
                                  setData({
                                    ...addData,
                                    add2: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>

                          <div
                            className="d-flex align-items-center"
                            style={{ marginBottom: "5px" }}
                          >
                            <div className="d-flex-1 ps-0 p-r-5">
                              <input
                                type="text"
                                className="Treatment-page-modal-form-control"
                                placeholder="City"
                                value={addData?.city}
                                onFocus={(e) => {
                                  e.target.style.color = "black";
                                  e.target.placeholder = "";
                                }}
                                onBlur={(e) => {
                                  e.target.style.color = "var(--primary-25)";
                                  e.target.placeholder = "City";
                                }}
                                onChange={(e) => {
                                  setData({
                                    ...addData,
                                    city: e.target.value,
                                  });
                                }}
                              />
                            </div>

                            <div
                              style={{
                                minWidth: "130px",
                              }}
                              className="col-md-2 ps-0 height-25 p-r-5 custom-select-new-provider"
                            >
                              <div
                                className="dropdown-button rounded-0 p-0 p-l-5 form-control height-25 d-flex align-items-center"
                                onClick={handleStateShow}
                              >
                                <span id="selectedOption">
                                  {specialStates.includes(addData?.state) ? (
                                    <div className="d-flex align-items-center">
                                      {React.createElement(stateMap[addData?.state])}
                                      {addData?.state}
                                    </div>
                                  ) : addData?.state ? (
                                    <div className="d-flex align-items-center">
                                      <svg
                                        style={{
                                          width: "15px",
                                          height: "15px",
                                          fill: "var(--primary-80)",
                                          color: "var(--primary-80)",
                                          stroke: "var(--primary-80)",
                                        }}
                                        className={`icon icon-state-${addData?.state}`}
                                      >
                                        <use xlinkHref={`#icon-state-${addData?.state}`} />
                                      </svg>
                                      {addData?.state}
                                    </div>
                                  ) : (
                                    "Select State"
                                  )}
                                </span>
                              </div>
                            </div>

                            <div
                              style={{
                                minWidth: "70px",
                              }}
                              className="col-md-1 ps-0 p-r-5"
                            >
                              <input
                                type="text"
                                className="Treatment-page-modal-form-control"
                                placeholder="Zip"
                                value={addData?.zip}
                                onFocus={(e) => {
                                  e.target.style.color = "black";
                                  e.target.placeholder = "";
                                }}
                                onBlur={(e) => {
                                  e.target.style.color = "var(--primary-25)";
                                  e.target.placeholder = "Zip";
                                }}
                                onChange={(e) => {
                                  setData({
                                    ...addData,
                                    zip: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>

                          <div
                            className="d-flex align-items-center"
                            style={{ marginBottom: "5px" }}
                          >
                            {/* <div className="m-r-5 text-end" style={{ width: "100px" }}>
                                  <span className="d-inline-block text-grey">Phone:</span>
                                </div> */}
                            <div className="col-md-6 ps-0 p-r-5">
                              <input
                                type="text"
                                id="completed_phone"
                                className="Treatment-page-modal-form-control"
                                name="medical_phone"
                                placeholder="Phone"
                                value={addData?.phone}
                                onFocus={(e) => {
                                  e.target.style.color = "black";
                                  e.target.placeholder = "";
                                }}
                                onBlur={(e) => {
                                  e.target.style.color = "var(--primary-25)";
                                  e.target.placeholder = "Phone";
                                }}
                                onChange={(e) => {
                                  handlePhoneChange(e);
                                }}
                              />
                            </div>
                            <div className="col-md-6 ps-0 p-r-5">
                              <input
                                type="text"
                                id="completed_fax"
                                className="Treatment-page-modal-form-control"
                                name="medical_fax"
                                placeholder="Fax"
                                value={addData?.fax}
                                onFocus={(e) => {
                                  e.target.style.color = "black";
                                  e.target.placeholder = "";
                                }}
                                onBlur={(e) => {
                                  e.target.style.color = "var(--primary-25)";
                                  e.target.placeholder = "Fax";
                                }}
                                onChange={(e) => {
                                  setData({
                                    ...addData,
                                    fax: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>

                          <div
                            className="d-flex align-items-center"
                            style={{ marginBottom: "5px" }}
                          >
                            {/* <div className="m-r-5 text-end" style={{ width: "100px" }}>
                                  <span className="d-inline-block text-grey">Website:</span>
                                </div> */}
                            <div className="col-md-6 ps-0 p-r-5">
                              <input
                                type="text"
                                id="completed_email"
                                className="Treatment-page-modal-form-control"
                                name="medical_email"
                                placeholder="Email"
                                value={addData?.email}
                                onFocus={(e) => {
                                  e.target.style.color = "black";
                                  e.target.placeholder = "";
                                }}
                                onBlur={(e) => {
                                  e.target.style.color = "var(--primary-25)";
                                  e.target.placeholder = "Email";
                                }}
                                onChange={(e) => {
                                  setData({
                                    ...addData,
                                    email: e.target.value,
                                  });
                                }}
                              />
                            </div>
                            <div className="col-md-6 ps-0 p-r-5">
                              <input
                                type="text"
                                id="completed_website"
                                className="Treatment-page-modal-form-control"
                                name="medical_website"
                                placeholder="Website"
                                value={addData?.webUrl}
                                onFocus={(e) => {
                                  e.target.style.color = "black";
                                  e.target.placeholder = "";
                                }}
                                onBlur={(e) => {
                                  e.target.style.color = "var(--primary-25)";
                                  e.target.placeholder = "Website";
                                }}
                                onChange={(e) => {
                                  setData({
                                    ...addData,
                                    webUrl: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>

                          {stateShow && (
                            <SelectStateModal
                              show={stateShow}
                              handleClose={handleStateShow}
                              onChange={(state) => {
                                setData({
                                  ...addData,
                                  state: state.StateAbr,
                                });
                              }}
                              statesData={statesAbrs}
                            />
                          )}
                        </div>
                      </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey={"damageDescription"}>
                      <div className="d-flex flex-column mx-auto align-items-center">
                        <div className="row mx-0 align-items-center custom-margin-bottom w-100">
                          <div className="col-md-2 text-start p-l-5 pe-0">
                            <span
                              id={`${formId}-damage-severity-label`}
                              className="d-flex align-items-center text-nowrap"
                            >
                              Damage Severity
                            </span>
                          </div>
                          <div
                            className="col-md-10 p-l-5 p-r-5 d-flex align-items-center"
                            role="radiogroup"
                            aria-labelledby={`${formId}-damage-severity-label`}
                          >
                            {["Minor", "Moderate", "Major"].map((severity) => (
                              <div
                                key={severity}
                                className="d-flex align-items-center me-2"
                                style={{ gap: "5px" }}
                              >
                                <input
                                  id={`${formId}-damage-severity-${severity}`}
                                  name={`${formId}-damage-severity`}
                                  className="form-check mb-0"
                                  style={{ minHeight: "14px" }}
                                  type="radio"
                                  value={severity}
                                  checked={addData.damageSeverity === severity}
                                  onChange={() =>
                                    setData((currentData) => ({
                                      ...currentData,
                                      damageSeverity: severity,
                                    }))
                                  }
                                />
                                <label
                                  className="form-check-label mb-0"
                                  htmlFor={`${formId}-damage-severity-${severity}`}
                                >
                                  {severity}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="col-12 p-l-5 p-r-5">
                          <label className="m-b-5">Damage Description</label>
                        </div>
                        <div className="col-12 p-l-5 p-r-5">
                          <textarea
                            className="form-control h-100px"
                            style={{
                              height: "100px",
                            }}
                            placeholder="Enter Damage Description Description"
                            onChange={(e) => {
                              setData({
                                ...addData,
                                damageDescription: e.target.value,
                              });
                            }}
                            value={addData?.damageDescription}
                          />
                        </div>
                      </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey={"additionalPDExp"}>
                      <div className="d-flex flex-column mx-auto align-items-center">
                        <div className="col-12 p-l-5 p-r-5">
                          <label className="m-b-5">Additional PD Expesne</label>
                        </div>
                        <div className="col-12 p-l-5 p-r-5">
                          <textarea
                            className="form-control h-100px"
                            style={{
                              height: "100px",
                            }}
                            placeholder="Enter Additional Personal Damage Expenses"
                            onChange={(e) => {
                              setData({
                                ...addData,
                                additionalPdExp: e.target.value,
                              });
                            }}
                            value={addData?.additionalPdExp}
                          />
                        </div>
                      </div>
                    </Tab.Pane>

                    <Tab.Pane eventKey={"insuranceResponsible"}>
                      <PropertyDamageInsuranceTab
                        insurances={insurancesData}
                        selectedInsurance={addData.selectedinsurance}
                        onSelect={(selectedinsurance) =>
                          setData((currentData) => ({ ...currentData, selectedinsurance }))
                        }
                      />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Tab.Container>
            </div>
          </Modal.Body>

          <Modal.Footer
            className="p-0 mt-0 padding-outside-btn-new-provider"
            style={{ borderTop: "none" }}
          >
            <Button
              className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
              variant="secondary"
              onClick={handleClose}
            >
              Cancel
            </Button>
            {isEdit && (
              <Button
                className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
                variant="danger"
                onClick={handleDelete}
              >
                Delete
              </Button>
            )}
            <Button
              variant={"success"}
              //   disabled={allTreatmentDates.length === 0}
              //   style={{
              //     cursor: allTreatmentDates.length === 0 ? "not-allowed" : "pointer",
              //   }}
              onClick={handleSave}
              disabled={saving}
              className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
            >
              {isEdit ? "Edit Property Damage" : "Add Property Damage"}
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
}

export default React.memo(EditModalDamage);
